import React from 'react';

interface ApimProductBadgeProps {
    productId: string;
}

const BADGE_COLORS = [
    'bg-primary',
    'bg-secondary',
    'bg-success',
    'bg-info text-dark',
    'bg-warning text-dark',
    'bg-danger',
];

const hashProductId = (id: string): number => {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
        hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
    }
    return hash;
};

export const ApimProductBadge: React.FC<ApimProductBadgeProps> = ({ productId }) => {
    const colorClass = BADGE_COLORS[hashProductId(productId) % BADGE_COLORS.length];

    return (
        <span className={`badge ${colorClass} me-1 mb-1`}>
            {productId}
        </span>
    );
};
